<div *appFeaturesAuth="{section:'DIV',identifier:'HELP.FRESH_DESK_LINK'}">
    <a href={{freshDeskLink}} target="_blank" class="go-back nodec">Fresh Desk</a>
</div>
<div *appFeaturesAuth="{section:'DIV',identifier:'HELP.VTE_LINK'}">
    <a href="https://infocert.vtecrm.net/" target="_blank" class="go-back nodec">VTE</a>
</div>
<div>
    <a *ngIf="manualLink" href={{manualLink}} target="_blank" rel="noopener" class="go-back nodec">{{ 'MANUAL' |
        translate}}</a>
</div>
<div *ngIf="raoNumber$ | async">
    <div *appFeaturesAuth="{section:'DIV',identifier:'HELP.RAO_NUMBER'}">
        <a href="tel:{{raoNumber$ | async}}" class="go-back nodec">RAO {{raoNumber$ | async}} <em class="fas fa-phone"></em></a>
    </div>
</div>